export interface IOptionsState {
  aiAssistantMode: boolean
  aiAssistantPercent: number
  buttonScrollMode: boolean
  keyboardMode: boolean
}

export const OptionsInitialState: IOptionsState = {
  buttonScrollMode: false,
  keyboardMode: false,
  aiAssistantMode: false,
  aiAssistantPercent: 70
}
